const emailValidationReducer = (email: string): boolean => {
  // Implement your email validation logic here
  // Return true if the email is valid, false otherwise
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export default emailValidationReducer;
